import React from "react";
import {autobind} from "core-decorators";
import {observable} from "mobx";
import {observer, Provider} from "mobx-react";
import {Router} from "react-router-dom";

import "@/styles/ant-design/custom-theme.less";
import "./App.scss";
import {Routes} from "@/routes";
import EnvCorner from "@/components/StageCorner/StageCorner";
import Store from "@/stores";
import StoreContext from "@/stores/StoreContext";

export interface IAppProps {
  store: Store;
}

@autobind
@observer
export default class App extends React.Component<IAppProps> {
  @observable protected store = new Store();

  render() {
    const {store} = this.props;
    return (
      <StoreContext.Provider value={store}>
        <Provider store={store}>
          <Router history={store.history.history}>
            <Routes />
          </Router>
          <EnvCorner />
        </Provider>
      </StoreContext.Provider>
    );
  }
}
